// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCartButton_wrapper__dBBXP","floatingContentWrapper":"HeaderCartButton_floatingContentWrapper__fwziR"};